<template>
  <div class="sf-pad-2">
    <div class="sf-subnav">
      <div class="sf-subnav-inner sf-level sf-level-center" role="tablist">
        <div class="sf-subnav-item sf-level-item">
          <a
            id="permanent-documents-tab"
            role="button"
            tabindex="0"
            :class="categoriesActiveClass"
            @click.stop="categoriesClick"
          >
            <span class="sf-font-s sf-pad-t-1 sf-pad-b-1">
              {{
                I18n.t(
                  'components.document.existing_docs_modal.permanent_documents'
                )
              }}
            </span>
          </a>
        </div>
        <div class="sf-subnav-item sf-level-item">
          <a
            id="period-documents"
            role="button"
            tabindex="0"
            :class="documentsActiveClass"
            @click.stop="documentsClick"
          >
            <span class="sf-font-s sf-pad-t-1 sf-pad-b-1">
              {{
                I18n.t(
                  'components.document.existing_docs_modal.period_specific_documents'
                )
              }}
            </span>
          </a>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="sf-pad-t-1">
      <ExistingDocumentsTable
        :entries="entries"
        :selected-entries-ids="selectedEntriesIds"
        :navigate="navigateTo"
        :permanent-category="permanentCategory"
        :replacement="replacement"
        :toggle-selection="toggleSelection"
        :current-page="showDocuments ? 1 : page"
        :total-pages="showDocuments ? 1 : totalPages"
        @change-page="changePage"
        @attach="attach"
        @back="back"
        @search="search"
      />
    </div>

    <div v-else-if="loading" class="sf-level sf-level-around sf-pad-3">
      <i class="icon-spinner icon-spin export-spinner" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import SFetch from '@app/utils/sfetch'
import ExistingDocumentsTable from '@app/application/reconciliation/sections/existing-documents-table'
import useI18n from '@app/shared/vue/composables/use-I18n'

export default {
  name: 'SelectExistingDocument',

  components: {
    ExistingDocumentsTable,
  },

  props: {
    replacement: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['attach', 'back'],

  setup() {
    const I18n = useI18n()

    return {
      I18n,
    }
  },

  data() {
    return {
      showDocuments: false,
      documents: [],
      permanentEntries: [],
      permanentCategory: null,
      category: null,
      entries: [],
      selectedEntries: [],
      page: 1,
      totalPages: 1,
      loading: false,
    }
  },

  computed: {
    categoriesActiveClass() {
      return this.showDocuments ? '' : 'active'
    },
    documentsActiveClass() {
      return this.showDocuments ? 'active' : ''
    },
    selectedEntriesIds() {
      return this.selectedEntries.map((e) => e.id)
    },
  },

  mounted() {
    this.loading = true
    this.fetchCategories()
    this.fetchDocuments()
  },

  methods: {
    back() {
      this.$emit('back')
    },
    attach() {
      this.$emit('attach', this.selectedEntries)
    },
    changePage(page) {
      this.page = page
      this.fetchCategories(
        this.permanentCategory
          ? { permanent_category_id: this.permanentCategory.id }
          : {}
      )
    },
    categoriesClick() {
      this.showDocuments = false
      this.updateEntries()
    },
    documentsClick() {
      this.showDocuments = true
      this.updateEntries()
    },
    updateEntries() {
      if (this.showDocuments) {
        this.entries = this.documents
        this.category = null
      } else {
        this.entries = this.permanentEntries
        this.category = this.permanentCategory
      }
    },
    toggleSelection(entry) {
      if (this.selectedEntries.some((e) => e.id === entry.id)) {
        this.selectedEntries = this.selectedEntries.filter(
          (e) => e.id !== entry.id
        )
      } else {
        if (this.replacement && this.selectedEntries.length === 1) return

        this.selectedEntries.push(entry)
      }
    },
    navigateTo(category) {
      this.loading = true
      this.page = 1
      this.fetchCategories({ permanent_category_id: category.id })
    },
    search: _.debounce(function (query) {
      const params = query ? { q: query } : {}

      if (this.showDocuments) this.fetchDocuments(params)
      else this.fetchCategories(params)
    }, 300),
    fetchCategories(params = {}) {
      const url = Silverfin.Routes.select_from_documents_permanent_entries_path(
        {
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          with_documents: true,
          page: this.page,
          ...params,
          _options: true,
        }
      )

      SFetch.json(url, { method: 'GET' }).then((response) => {
        this.permanentEntries = response.permanentEntries
        this.permanentCategory = response.permanentCategory
        this.page = response.currentPage
        this.totalPages = response.totalPages
        this.updateEntries()
        this.loading = false
      })
    },
    fetchDocuments(params = {}) {
      const url =
        Silverfin.Routes.period_specific_documents_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          ...params,
          _options: true,
        })

      SFetch.json(url, { method: 'GET' }).then((response) => {
        this.documents = response
        this.updateEntries()
        this.loading = false
      })
    },
  },
}
</script>
